
import { useDropzone } from "react-dropzone";
import { Upload, Folder } from "lucide-react";

interface DropZoneProps {
  onDrop: (files: File[]) => void;
  isDragActive: boolean;
  getInputProps: () => JSX.IntrinsicElements['input'];
  getRootProps: () => JSX.IntrinsicElements['div'];
}

// Extender la interfaz InputHTMLAttributes para incluir los atributos de directorio
declare module 'react' {
  interface InputHTMLAttributes<T> extends HTMLAttributes<T> {
    webkitdirectory?: string;
    directory?: string;
  }
}

export function DropZone({ onDrop, isDragActive, getInputProps, getRootProps }: DropZoneProps) {
  return (
    <div
      {...getRootProps()}
      className={`relative border-2 border-dashed rounded-lg p-12 transition-all duration-300 ease-in-out text-center cursor-pointer
        ${isDragActive ? "border-transfer-accent bg-blue-50" : "border-white/50 hover:border-white"}`}
    >
      <input {...getInputProps()} />
      <div className="flex justify-center space-x-2 mb-4">
        <Upload
          className={`h-12 w-12 transition-colors duration-300
            ${isDragActive ? "text-transfer-accent" : "text-white"}`}
        />
        <Folder
          className={`h-12 w-12 transition-colors duration-300
            ${isDragActive ? "text-transfer-accent" : "text-white"}`}
        />
      </div>
      <p className="text-lg font-medium text-white mb-1">
        {isDragActive ? "Drop files or folders here" : "Drag & drop files or folders here"}
      </p>
      <p className="text-sm text-white/80">
        or click to select
      </p>
    </div>
  );
}
